export enum BannerSlugEnum {
	'HAS_ACTIVE_DEFERRED_PAYMENT' = 'HAS_ACTIVE_DEFERRED_PAYMENT',
	'HAS_NO_ACTIVE_DEFERRED_PAYMENT' = 'HAS_NO_ACTIVE_DEFERRED_PAYMENT',
	'HAS_ACTIVE_PAY_IN_THREE' = 'HAS_ACTIVE_PAY_IN_THREE',
	'HAS_NO_ACTIVE_PAY_IN_THREE' = 'HAS_NO_ACTIVE_PAY_IN_THREE',
	'HAS_ACTIVE_DEFERRED_AND_PAY_IN_THREE' = 'HAS_ACTIVE_DEFERRED_AND_PAY_IN_THREE',
	'HAS_NO_ACTIVE_DEFERRED_AND_PAY_IN_THREE' = 'HAS_NO_ACTIVE_DEFERRED_AND_PAY_IN_THREE',
	'HAS_PREFERRED_BANK' = 'HAS_PREFERRED_BANK',
	'HAS_NO_PREFERRED_BANK' = 'HAS_NO_PREFERRED_BANK',
}
